module.exports = __webpack_public_path__ + "img/zeus.33bae9da.png";